import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-final-form';
import { useRouter } from 'next/router';
import { Chips } from '../../ui/Chips';
import { InitialRentalTabsContainer, TabLink } from './styled';
import { RentalTabsProps } from './types';
import { mobileTabsConfig } from './tabsConfig';
import useScreenSize from '../../../hooks/useScreenSize';
import {
  SEARCH_RESULT_ROUTES,
  isRentLandingPath
} from '../../../utils/helpers/constants';
import { useClient } from '../../../hooks/useClient';

export const RentalTabs = ({ values }: RentalTabsProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { change } = useForm();
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const router = useRouter();
  const isSalePage = router.asPath === SEARCH_RESULT_ROUTES.SALE;
  const isRentPage = isRentLandingPath(router.asPath);

  if (isClient && (isSalePage || isRentPage) && isSmall) return null;

  if (isClient && !isSmall) {
    return null;
  }

  return (
    <InitialRentalTabsContainer data-cy="new-search__chips-wrapper">
      {mobileTabsConfig.map(tab => {
        const isPasha = tab.cypress === 'pasha';
        return (
          <TabLink
            key={tab.id}
            id={tab.id}
            href={tab.href}
            locale={false}
            prefetch={false}
            className={isPasha ? 'rental-tabs__pasha' : undefined}
          >
            <Chips
              type="button"
              icon={tab.icon}
              cypress={tab.cypress}
              borderRadius="14px"
              text={isPasha ? <Trans i18nKey={tab.text} /> : t(tab.text)}
              stat={tab.stat}
              onClick={() => tab.onClick({ change, values, dispatch })}
              isTextPadding={false}
            />
          </TabLink>
        );
      })}
    </InitialRentalTabsContainer>
  );
};
